export const LogConstants = {
  CHANNEL: 'mln-ui',
};
